var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "tx_stats"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" ID "), _c('Tooltip', {
    attrs: {
      "content": "Unique Identifier of this transaction"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values hash"
  }, [_vm._v(" " + _vm._s(_vm.tx.hash) + " "), _c('CopyText', {
    attrs: {
      "value": _vm.tx.hash
    }
  })], 1)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Block "), _c('Tooltip', {
    attrs: {
      "content": "The number of the block in which the transaction was recorded."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": {
        path: "/evmblock/".concat(_vm.tx.block || parseInt(_vm.tx.blockNumber, 16), "?network=").concat(_vm.DEFAULT_NETWORK_NAME),
        query: {
          network: _vm.DEFAULT_NETWORK_NAME,
          subnet: _vm.hasSubnet ? _vm.subnetName : null
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.tx.block || parseInt(_vm.tx.blockNumber, 16)))])], 1)]), !_vm.hasSubnet ? _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Timestamp "), _c('Tooltip', {
    attrs: {
      "content": "The date and time when this transaction was accepted by the DComm Network"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('fa', {
    staticClass: "time_icon",
    attrs: {
      "icon": ['far', 'clock']
    }
  }), _vm._v(" " + _vm._s(_vm._f("fromNow")(_vm.date.getTime())) + " (" + _vm._s(_vm.date.toUTCString()) + ") ")], 1)]) : _vm._e(), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" From "), _c('Tooltip', {
    attrs: {
      "content": "The sending account of the transaction"
    }
  })], 1), _vm.tx.fromAddr || _vm.tx.from ? _c('div', {
    staticClass: "meta_value values"
  }, [!_vm.hasSubnet ? _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/evmaddress/".concat(_vm.tx.fromAddr || _vm.tx.from, "?network=").concat(_vm.DEFAULT_NETWORK_NAME)
    }
  }, [_vm._v(_vm._s(_vm.tx.from || _vm.tx.fromAddr) + " ")]) : _c('span', [_vm._v(_vm._s(_vm.tx.from))]), _c('CopyText', {
    attrs: {
      "value": _vm.tx.fromAddr || _vm.tx.from
    }
  })], 1) : _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v("NA")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" To "), _c('Tooltip', {
    attrs: {
      "content": "The receiving account of the transaction (could be a action address)."
    }
  })], 1), _vm.tx.toAddr || _vm.tx.recipient || _vm.tx.to ? _c('div', {
    staticClass: "meta_value values"
  }, [!_vm.hasSubnet ? _c('router-link', {
    staticClass: "link",
    attrs: {
      "to": "/evmaddress/".concat(_vm.tx.toAddr || _vm.tx.recipient, "?network=").concat(_vm.DEFAULT_NETWORK_NAME)
    }
  }, [_vm._v(" " + _vm._s(_vm.tx.toAddr || _vm.tx.recipient || _vm.tx.to) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.tx.toAddr || _vm.tx.recipient || _vm.tx.to) + " ")]), _c('CopyText', {
    attrs: {
      "value": _vm.tx.toAddr || _vm.tx.recipient
    }
  })], 1) : _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v("NA")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Value "), _c('Tooltip', {
    attrs: {
      "content": "The value being transacted in DCM."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(_vm._s(_vm.value) + " DCM")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Price "), _c('Tooltip', {
    attrs: {
      "content": "Cost per unit of gas specified for the transaction, in DCM and nDCM."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.hasSubnet ? _vm.gas(parseInt(_vm.tx.gasPrice, 16).toString()) : _vm.tx.gasPrice) + " DCM ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Limit "), _c('Tooltip', {
    attrs: {
      "content": "Maximum amount of gas provided for the transaction. For normal DCM transfers, the value is 21,000. For action calls, this value is higher and bound by block gas limit."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.hasSubnet ? parseInt(_vm.tx.gas, 16).toString() : _vm.tx.gasLimit) + " ")])]), _c('transition-group', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.moreDetails ? _c('article', {
    key: "1",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Nonce "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the number of transactions sent by the sender"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.hasSubnet ? parseInt(_vm.tx.nonce, 16) : _vm.tx.nonce) + " ")])]) : _vm._e(), _vm.moreDetails ? _c('article', {
    key: "2",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Max Fee Per Gas "), _c('Tooltip', {
    attrs: {
      "content": "Maximum fee per gas used"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.hasSubnet ? parseInt(_vm.tx.maxFeePerGas, 16) : _vm.tx.maxFeePerGas) + " ")])]) : _vm._e(), _vm.moreDetails ? _c('article', {
    key: "3",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Max priority Fee Per Gas "), _c('Tooltip', {
    attrs: {
      "content": "Maximum priority fee per gas used"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.hasSubnet ? parseInt(_vm.tx.maxPriorityFeePerGas, 16) : _vm.tx.maxPriorityFeePerGas) + " ")])]) : _vm._e()]), _c('span', {
    staticClass: "more",
    on: {
      "click": _vm.toggleMore
    }
  }, [!_vm.moreDetails ? _c('span', [_vm._v("Click to see more")]) : _c('span', [_vm._v("Click to hide")]), _vm.moreDetails === false ? _c('fa', {
    attrs: {
      "icon": "arrow-down"
    }
  }) : _c('fa', {
    attrs: {
      "icon": "arrow-up"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }